export default __webpack_public_path__ + "be8081d069638524b055f6790b4badeb.jpg";